import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-grey" }
const _hoisted_2 = { class: "error-details pa-2 rounded" }

import { ref } from 'vue';
  import { api } from '@/services/api';
  import type errorModel from '@/models/errorModel';
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorsView',
  props: {
    errors: {}
  },
  emits: ['error-deleted'],
  setup(__props: any, { emit: __emit }) {

  const props = __props;

  const emit = __emit;
  const deletingId = ref<string | null>(null);

  const getErrorClass = (errorMessage: string) => {
    if (errorMessage.includes('Unauthorized')) {
      return 'error-unauthorized'
    }
    if (errorMessage.includes('BadRequest')) {
      return 'error-badrequest'
    }
    return 'error-default'
  }

  const deleteError = async (customerId: string, errorId: string) => {
    try {
      deletingId.value = customerId;
      await api.deleteError(customerId, errorId);
      emit('error-deleted');
    } catch (error) {
      console.error('Error deleting error:', error);
    } finally {
      deletingId.value = null;
    }
  };
  
return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_text = _resolveComponent("v-list-item-text")!
  const _component_v_list_group = _resolveComponent("v-list-group")!

  return (_openBlock(), _createBlock(_component_v_list_group, null, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
        prepend: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: "mdi-alert",
            class: "mr-2"
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_title, null, {
            default: _withCtx(() => [
              _createTextVNode("Errors: " + _toDisplayString(_ctx.errors?.length || 0), 1)
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
        return (_openBlock(), _createBlock(_component_v_list_group, {
          key: error.customerId,
          class: "error-item mb-2"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
              class: [getErrorClass(error.errorMessage), "rounded"]
            }), {
              append: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  icon: "mdi-delete",
                  size: "small",
                  color: "error",
                  variant: "text",
                  onClick: _withModifiers(($event: any) => (deleteError(error.customerId, error.id)), ["stop"]),
                  loading: deletingId.value === error.customerId
                }, null, 8, ["onClick", "loading"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.errorMessage), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1040, ["class"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, { class: "pl-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, "Created at: " + _toDisplayString(new Date(error.createdAt).toLocaleString()), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_list_item, { class: "pl-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("pre", _hoisted_2, _toDisplayString(error.errorDetails), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})